var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incompleted-candidature--container"},[_c('p',[_vm._v(_vm._s(_vm.$t('internal.mobility:incompleted.candidature.description')))]),_c('div',{staticClass:"incompleted-candidature--list"},[(_vm.isLoading)?_c('div',{staticClass:"skeleton-incomplete"},_vm._l((['a', 'b', 'c']),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"skeleton-card-incomplete max-width",attrs:{"height":"80px","type":"list-item-avatar-two-line"}})}),1):_vm._l((this.getPositonsIncomplete),function(item){return _c('candidature-card',{key:item.id,attrs:{"candidature":{
        position: {
          company: {
            logo: item.company.logo,
            name: item.company.name,
            url: item.positionUrl
          },
          title: item.title,
          status: item.status,
        },
        stepsLeft: 1,
      }},on:{"handleModalMessage":function($event){return _vm.handleShowModalMessages(item)}}})})],2),(_vm.showModal)?_c('modal-messages',{attrs:{"company":_vm.company,"position":_vm.position},on:{"close":function($event){_vm.showModal = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }